import { combineReducers } from "redux";
import { ScopeLoadingState } from "./scope-loading/types";
import { ScopeErrorState } from "./scope-error/types";
import { scopeLoadingReducer } from "./scope-loading/reducer";
import { scopeErrorReducer } from "./scope-error/reducer";
import { UserState } from "./user/types";
import { userReducer } from "./user/reducer";
import { claimReducer } from "./claim/reducer";
import { ClaimState } from "./claim/types";
import { WarrntyItemState } from "./add-warrnty-item/types";
import { warrntyItemReducer } from "./add-warrnty-item/reducer";
import { contactServiceReducer } from "./contact-service/reducer";
import { ContactServiceState } from "./contact-service/types";
import { AceClaimState } from "./ace-claim/types";
import { aceClaimReducer } from "./ace-claim/reducer";

export interface RootState {
  scopeLoading: ScopeLoadingState;
  scopeError: ScopeErrorState;
  user: UserState;
  claim: ClaimState;
  warrntyItem: WarrntyItemState;
  contactService: ContactServiceState;
  aceClaim: AceClaimState;
}

const createRootReducer = () =>
  combineReducers({
    user: userReducer,
    claim: claimReducer,
    warrntyItem: warrntyItemReducer,
    scopeLoading: scopeLoadingReducer,
    scopeError: scopeErrorReducer,
    contactService: contactServiceReducer,
    aceClaim: aceClaimReducer,
  });

export default createRootReducer;
